import React from 'react';
import { Alert, Card, CardBody } from 'reactstrap';
import { COUNTER_ACCENT } from '../constants';

export const DetailItem = ({
  label,
  value,
  isHtml = false,
  highlight = false,
}) => (
  <div
    className={highlight ? 'ps-3' : 'border-start border-2 border-primary ps-3'}
    style={
      highlight ? { borderLeft: `2px solid ${COUNTER_ACCENT}` } : undefined
    }
  >
    <div
      className={
        highlight
          ? 'small fw-semibold mb-1'
          : 'text-muted small fw-semibold mb-1'
      }
      style={highlight ? { color: COUNTER_ACCENT } : undefined}
    >
      {label}
    </div>
    {isHtml ? (
      value ? (
        <div className='html-content-panel'>
          <div
            className='html-content-body'
            dangerouslySetInnerHTML={{ __html: value }}
          />
        </div>
      ) : (
        <div className='text-dark fs-13 mb-0 lh-base'>-</div>
      )
    ) : (
      <div
        className={
          highlight
            ? 'fs-13 mb-0 lh-base fw-semibold'
            : 'text-dark fs-13 mb-0 lh-base'
        }
        style={highlight ? { color: COUNTER_ACCENT } : undefined}
      >
        {value || '-'}
      </div>
    )}
  </div>
);

export const SectionHeader = ({ title, subtitle, countLabel }) => (
  <div className='d-flex align-items-start justify-content-between gap-3 mb-3'>
    <div>
      <h5 className='fw-bold text-dark mb-1'>{title}</h5>
      {subtitle && <p className='text-muted small mb-0'>{subtitle}</p>}
    </div>
    {countLabel != null && countLabel !== '' && (
      <span className='badge bg-primary-subtle text-primary rounded-pill fw-medium fs-12 flex-shrink-0'>
        {countLabel}
      </span>
    )}
  </div>
);

export const SectionCard = ({
  children,
  className = 'mb-4 border shadow-sm',
}) => (
  <Card className={className}>
    <CardBody>{children}</CardBody>
  </Card>
);

export const LoadingSpinner = () => (
  <div className='text-center py-5'>
    <div className='spinner-border text-primary' role='status'>
      <span className='visually-hidden'>Loading...</span>
    </div>
  </div>
);

export const SectionAlert = ({
  tone = 'warning',
  icon = 'ri-alert-line',
  title,
  children,
  className = 'mb-0 mb-4',
  titleClassName = 'fs-14',
}) => {
  const toneClass =
    tone === 'info'
      ? 'bg-info-subtle text-primary'
      : 'bg-warning-subtle text-warning';

  return (
    <Alert
      className={`${toneClass} alert-solid alert-label-icon ${className}`}
      fade={false}
    >
      <i className={`${icon} label-icon`}></i>
      <div>
        <div className={`fw-semibold text-dark mb-1 ${titleClassName}`}>
          {title}
        </div>
        {children}
      </div>
    </Alert>
  );
};
